// extracted by mini-css-extract-plugin
export default {"main":"about_main__XToPN","about":"about_about__O9ljK","about_Des":"about_about_Des__a+ig8","icon":"about_icon__rzjHO"};